import img9 from '../.././Image/img9.jpg'
import img5 from '../.././Image/img5.PNG'
import img6 from '../.././Image/img6.jpg'

function Security() {
    return (

        <>
            <div className="inline-grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 justify-center place-items-center">

                <div className="overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow w-[300px] h-[300px]">
                    <img
                        src={img9}
                        className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                    />
                </div>

                <div className="overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow w-[300px] h-[300px]">
                    <img
                        src={img5}
                        className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                    />
                </div>

                <div className="overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow w-[300px] h-[300px]">
                    <img
                        src={img6}
                        className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                    />
                </div>

                    
            </div>

            <div className="text-white mx-4 sm:mx-10 md:mx-[80px] font-sans leading-relaxed mt-10 sm:mt-14 md:mt-16">           

                <h1 className="text-center text-2xl sm:text-3xl md:text-4xl font-extrabold mb-10 sm:mb-14 md:mb-16 
                    bg-gradient-to-r from-purple-400 to-blue-400 text-transparent bg-clip-text">
                    Design Documentation
                </h1>

                <div className="inline-grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-10">

                    <div className="w-full sm:w-[350px] md:w-[400px] lg:w-[450px] 
                        p-8 rounded-2xl bg-white/10 backdrop-blur-xl 
                         shadow-lg hover:scale-[1.02] transition duration-300 
                         border border-white/10">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">
                            Security Architecture Guide
                        </h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            A document outlining the overall security structure — data flow protection, authentication layers, encryption models, access levels, and system security hierarchy.
                        </p>
                    </div>

                    <div className="w-full sm:w-[350px] md:w-[400px] lg:w-[450px] 
                         p-8 rounded-2xl bg-white/10 backdrop-blur-xl 
                         shadow-lg hover:scale-[1.02] transition duration-300 
                         border border-white/10">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">
                            Security Policy Guidelines
                        </h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            Formal rules defining all security policies — data privacy rules, password standards, user access control, compliance requirements, and incident prevention protocols.
                        </p>
                    </div>

                    <div className="w-full sm:w-[350px] md:w-[400px] lg:w-[450px] 
                         p-8 rounded-2xl bg-white/10 backdrop-blur-xl 
                         shadow-lg hover:scale-[1.02] transition duration-300 
                         border border-white/10">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">
                            Security Framework Manual
                        </h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            Detailed instructions on security practices — encryption, firewalls, monitoring tools, vulnerability checks, API protection, and secure infrastructure configuration.
                        </p>
                    </div>

                    <div className="w-full sm:w-[350px] md:w-[400px] lg:w-[450px] 
                         p-8 rounded-2xl bg-white/10 backdrop-blur-xl 
                         shadow-lg hover:scale-[1.02] transition duration-300 
                         border border-white/10">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">
                            Security Best Practices Guide
                        </h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            Defines essential security practices — safe coding standards, secure data handling, identity protection, threat mitigation, and do’s & don’ts for users and developers.
                        </p>
                    </div>

                    <div className="w-full sm:w-[350px] md:w-[400px] lg:w-[450px] 
                         p-8 rounded-2xl bg-white/10 backdrop-blur-xl 
                         shadow-lg hover:scale-[1.02] transition duration-300 
                         border border-white/10">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">
                            Security Standards Manual
                        </h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            A complete guide containing recognized security standards — authentication rules, authorization patterns, risk assessment models, and compliance with global norms.
                        </p>
                    </div>

                    <div className="w-full sm:w-[350px] md:w-[400px] lg:w-[450px] 
                         p-8 rounded-2xl bg-white/10 backdrop-blur-xl 
                          shadow-lg hover:scale-[1.02] transition duration-300 
                          border border-white/10">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">
                            Security Operations Handbook
                        </h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            A compact overview of day-to-day security operations — monitoring processes, alert handling, threat detection workflows, and incident response procedures.
                        </p>
                    </div>

                    <div className="w-full sm:w-[350px] md:w-[400px] lg:w-[450px] 
                          p-8 rounded-2xl bg-white/10 backdrop-blur-xl 
                          shadow-lg hover:scale-[1.02] transition duration-300 
                          border border-white/10">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">
                            Security Component Library
                        </h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            A reusable set of security components — authentication modules, verification flows, encryption tools, permission systems, and secure API templates.
                        </p>
                    </div>

                    <div className="w-full sm:w-[350px] md:w-[400px] lg:w-[450px] 
                          p-8 rounded-2xl bg-white/10 backdrop-blur-xl 
                          shadow-lg hover:scale-[1.02] transition duration-300 
                          border border-white/10">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">
                            Security Identity Manual
                        </h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            Explains the system’s security identity — login flow, multi-factor authentication, user identity management, session rules, and secure access behavior.
                        </p>
                    </div>

                    <div className="w-full sm:w-[350px] md:w-[400px] lg:w-[450px] 
                          p-8 rounded-2xl bg-white/10 backdrop-blur-xl 
                          shadow-lg hover:scale-[1.02] transition duration-300 
                          border border-white/10">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">
                            Security System & Compliance Guide
                        </h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            A unified manual combining system security rules with compliance standards to support safe development across all platforms and products.
                        </p>
                    </div>

                    <div className="w-full sm:w-[350px] md:w-[400px] lg:w-[450px] 
                         p-8 rounded-2xl bg-white/10 backdrop-blur-xl 
                         shadow-lg hover:scale-[1.02] transition duration-300 
                         border border-white/10">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">
                            Security Strategy Guide
                        </h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            A strategic document outlining long-term security goals — risk analysis, threat modeling, compliance direction, roadmap planning, and security growth strategy.
                        </p>
                    </div>



                </div>

            </div>
        </>
    );
}
export default Security;